export class FileValidations {
  public static buildMultipartFiles(
    dataMultipart: FormData,
    multipartName: string,
    files: File[]
  ): FormData {
    if (files.length) {
      for (let index = 0; index < files.length; index++) {
        const element = files[index];
        dataMultipart.append(multipartName, element, element.name);
      }
    }
    return dataMultipart;
  }

  public static validateExtension(fileName: string) {
    const extensions = [
      'jpg',
      'png',
      'jpeg',
      'svg',
      'webp',
      'pdf',
      'xls',
      'xlsx',
      'docx',
      'doc',
      'pptx',
      'ppt',
      'odt',
      'csv',
    ];
    const extension = fileName?.split('.')?.pop()?.toLowerCase() ?? '';
    const validate = extensions.includes(extension) ? true : false;
    return validate;
  }

  public static validateFileImage(fileName: string) {
    const fileExtension = fileName.split('.').pop()?.toLowerCase();

    if (fileExtension) {
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
      return allowedExtensions.includes(fileExtension);
    }

    return false;
  }
}
